module.exports = __webpack_public_path__ + "img/mega_1.645e8200.png";